import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';

export const donationRoutes: Route[] = [
  {
    path: 'individuals-donation-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/individuals-donation-requests/individuals-donation-requests'
      ).then((mod) => mod.IndividualsDonationRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'individuals-furniture-donation-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/individuals-furniture-donation-requests/individuals-furniture-donation-requests'
      ).then((mod) => mod.IndividualsFurnitureDonationRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    // data: {
    //   allowedRoles: ['superAdmin', 'supervisor'],
    // },
  },
  {
    path: 'corps-donation-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/corps-donation-requests/corps-donation-requests'
      ).then((mod) => mod.CorpsDonationRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'corps-furniture-donation-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/corps-furniture-donation-requests/corps-furniture-donation-requests'
      ).then((mod) => mod.CorpsFurnitureDonationRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'donation-details/:donerType/:donationId',
    loadComponent: () =>
      import(
        '../../features/donations/pages/donation-details/donation-details'
      ).then((mod) => mod.DonationDetails),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'users-orders-requests/free-clothes-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/free-clothes-requests/free-clothes-requests'
      ).then((mod) => mod.FreeClothesRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'users-orders-requests/approved-clothes-requests',
    loadComponent: () =>
      import(
        '../../features/donations/pages/approved-clothes-requests/approved-clothes-requests'
      ).then((mod) => mod.ApprovedClothesRequests),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'order-details/:orderId',
    loadComponent: () =>
      import(
        '../../features/donations/pages/request-details/request-details'
      ).then((mod) => mod.RequestDetails),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
  },
];
